export default __webpack_public_path__ + "static/media/arrW.17182f07.svg";